import React from 'react';
import { Link } from 'react-router-dom';

// The seller as a named, vetted counterpart — the strip that sits under the
// product title on both product pages. Factory catalog passes the factory
// ("الصانع" → /factory/:id); the supplier storefront passes the supplier
// ("المورّد" → /supplier/:id). Same shape either way, so a buyer reads the two
// pages as one product experience.
//
// `verified` drives the check badge only: an unverified seller still renders
// here, just without the badge. A seller with no name renders NOTHING — the
// strip never shows "?" or "—" for a seller it knows nothing about (owner,
// 2026-10-03). `rating` shows only when there is one; `ctaLabel` ("شوف المصنع")
// replaces the bare chevron.
export default function SellerStrip({
  to, image, kicker, name, meta = '', verified = false, verifiedLabel = '', lang = 'ar',
  rating = null, ctaLabel = '',
}) {
  const isAr = lang === 'ar';
  const font = isAr ? 'var(--font-ar)' : 'var(--font-sans)';
  const shownName = String(name || '').trim();
  if (!shownName) return null;
  const initial = shownName[0];
  const rated = Number(rating) > 0;

  return (
    <Link to={to} style={{
      display: 'flex', alignItems: 'center', gap: 12, textDecoration: 'none',
      border: '1px solid var(--border)', borderRadius: 'var(--radius-card)',
      background: 'var(--bg-subtle)', padding: '11px 13px', margin: '0 0 12px',
    }}>
      {image
        ? <img src={image} alt="" style={{ width: 46, height: 46, borderRadius: '50%', objectFit: 'cover', flex: '0 0 auto', border: '1px solid var(--border)' }} />
        : <span style={{ width: 46, height: 46, borderRadius: '50%', flex: '0 0 auto', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Cormorant Garamond', serif", fontSize: 21, color: '#8B7355', background: 'var(--bg-hero)', border: '1.5px solid rgba(139,115,85,0.35)' }}>{initial}</span>}
      <div style={{ minWidth: 0, flex: 1 }}>
        <div style={{ fontSize: 9.5, letterSpacing: '0.16em', textTransform: 'uppercase', color: 'var(--text-muted)', fontWeight: 700, fontFamily: font }}>{kicker}</div>
        <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--text-primary)', display: 'flex', alignItems: 'center', gap: 6, lineHeight: 1.3, fontFamily: font }}>
          <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{shownName}</span>
          {verified && (
            <span style={{ flex: '0 0 auto', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 16, height: 16, borderRadius: '50%', background: 'var(--green)', color: '#fff', fontSize: 9.5 }}>✓</span>
          )}
        </div>
        {(meta || verified) && (
          <div style={{ fontSize: 11.5, color: 'var(--text-secondary)', marginTop: 2, fontFamily: font }}>
            {meta}{meta && verified ? ' · ' : ''}
            {verified && <span style={{ color: 'var(--green)', fontWeight: 700 }}>{verifiedLabel}</span>}
          </div>
        )}
        {rated && (
          <div style={{ fontSize: 11.5, color: 'var(--text-secondary)', marginTop: 2, fontFamily: font }}>
            <span style={{ color: '#e8a020' }}>★</span> {Number(rating).toFixed(1)}
          </div>
        )}
      </div>
      {ctaLabel
        ? <span style={{ flex: '0 0 auto', color: 'var(--text-primary)', fontSize: 12.5, textDecoration: 'underline', fontFamily: font }}>{isAr ? `${ctaLabel} ←` : `${ctaLabel} →`}</span>
        : <span style={{ flex: '0 0 auto', color: 'var(--text-muted)', fontSize: 18 }}>{isAr ? '‹' : '›'}</span>}
    </Link>
  );
}
